<template>
  <b-modal
    id="assign-operator-modal"
    cancel-variant="outline-secondary"
    :ok-title="isTransfer ? $t('button.transfer') : $t('chat.assign')"
    :cancel-title="$t('button.close')"
    centered
    no-close-on-backdrop
    :title="
      isTransfer
        ? $t('general.transferConversation')
        : $t('general.assignConversation')
    "
    @ok="handleOk"
  >
    <validation-observer ref="assignOperatorForm" #default="{ invalid }">
      <!-- form -->
      <n-form-confirmation
        ref="formConfirmation"
        key="assignOperatorForm"
        :message="$t('alert.assignTo', { operator: operatorName })"
        :confirm-button-text="`button.confirm`"
        :cancel-button-text="`button.no`"
        :form="$refs.assignOperatorForm"
        :disabled="invalid"
        @submit="submit"
      >
        <n-input :fields="formInput" v-model="data">
          <template #userId="item">
            <b-form-group
              :label-for="item.field.key"
              :class="item.field.class"
              :key="`selection-operator-${key}`"
            >
              <validation-provider
                #default="{ errors }"
                :vid="item.field.key"
                :name="item.field.label"
                :rules="item.field.rules"
              >
                <label class="d-block">
                  {{ $t("field.operator") }}
                </label>
                <n-async-single-select
                  v-model="user"
                  :ref="item.field.key"
                  :name="item.field.key"
                  :repository="item.field.repository"
                  :selection-key="item.field.selectionKey"
                  :selection-label="item.field.selectionLabel"
                  :readonly="item.field.disabled"
                  :clearable="item.field.clearable"
                  :reduce="false"
                  @input="onChangeOperator"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  :alwaysExcluded="userData.id"
                  exclude-key="id"
                  :excludes="[activeChannel.operatorAssigned]"
                >
                  <template #option="item">
                    {{ item.name }}
                    <b-badge
                      class="float-right mr-2"
                      variant="success"
                      v-if="item.isOnline"
                    >
                      {{ $t("general.online") }}
                    </b-badge>
                    <b-badge class="float-right mr-2" variant="danger" v-else>
                      {{ $t("general.offline") }}
                    </b-badge>
                  </template>
                </n-async-single-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </template>
        </n-input>
      </n-form-confirmation>
    </validation-observer>

    <template #modal-ok>
      <b-spinner small label="Spinning" v-if="loading"></b-spinner>
      <span v-else>
        {{ isTransfer ? $t("button.transfer") : $t("chat.assign") }}
      </span>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BSpinner, BFormGroup, BBadge } from "bootstrap-vue";
import FormInput from "./assignOperatorFormInput";
import NInput from "@/components/NInput";
import Repository from "@/repositories/RepositoryFactory";
import NFormConfirmation from "@/components/NFormConfirmation";
import NAsyncSingleSelect from "@/components/NAsyncSingleSelect.vue";
import useJwt from "@/auth/jwt/useJwt";

const ChatChannelRepository = Repository.get("chatChannel");

export default {
  components: {
    BModal,
    BSpinner,
    BFormGroup,
    BBadge,
    NFormConfirmation,
    NInput,
    NAsyncSingleSelect,
  },
  computed: {
    userData: function () {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName));
    },
  },
  props: {
    activeChannel: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      isTransfer: false,
      user: "",
      data: {
        token: "",
        userId: "",
      },
      operatorName: "",
      key: 1,
    };
  },
  methods: {
    show(token, isTransfer = false) {
      this.key++;
      this.isTransfer = isTransfer;
      this.data.token = token;
      this.data.userId = "";
      this.user = "";
      this.$bvModal.show("assign-operator-modal");
    },
    hide() {
      this.isTransfer = false;
      this.data.token = "";
      this.data.userId = "";
      this.user = "";
      this.$bvModal.hide("assign-operator-modal");
    },
    changeData(data) {
      this.data = {
        ...data,
      };
    },
    onChangeOperator(data) {
      this.data.userId = data.id;
      this.operatorName = data.name;
    },
    handleOk(bvModal) {
      bvModal.preventDefault();
      if (this.loading) {
        return;
      }

      this.$refs.assignOperatorForm.validate().then((success) => {
        if (success) {
          this.$refs.formConfirmation.confirm();
        }
      });
    },
    submit() {
      this.loading = true;
      ChatChannelRepository.assign(this.data)
        .then((response) => {
          this.hide();
          this.$emit("success");
        })
        .catch((error) => {
          if (error.response?.status == 422) {
            this.$refs.assignOperatorForm.setErrors(
              error.response?.data?.validate
            );
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  setup() {
    const formInput = [...FormInput];

    return {
      formInput,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
